var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"500"}},[_c('v-list',_vm._l((_vm.filteredItems),function(item,i){return _c('v-list-item',{key:i,on:{"click":function($event){return _vm.triggerEvent(item.event)}}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.text)}})],1)],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }